/** Save/share a generated file. Browser: download; devices: Web Share with a File when available (Capacitor Filesystem/Share in sprint 6.5+). */
export async function saveFile(name: string, mime: string, bytes: Uint8Array): Promise<void> {
  const blob = new Blob([bytes as BlobPart], { type: mime });
  const file = new File([blob], name, { type: mime });
  const nav = navigator as Navigator & { canShare?: (d: ShareData) => boolean };
  if (nav.canShare?.({ files: [file] })) {
    try { await navigator.share({ files: [file], title: name }); return; } catch { /* user cancelled → fall through */ }
  }
  const url = URL.createObjectURL(blob);
  const a = Object.assign(document.createElement("a"), { href: url, download: name });
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

/** Opens the document HTML in a print window (browser print → PDF; Tauri uses the same path). */
export function printHtml(html: string): void {
  const w = window.open("", "_blank", "noopener");
  if (!w) return;
  w.document.open(); w.document.write(html); w.document.close();
  w.addEventListener("load", () => { w.focus(); w.print(); });
}

export function getPosition(): Promise<{ lat: number; lng: number; accuracy?: number } | null> {
  return new Promise((res) => {
    if (!navigator.geolocation) return res(null);
    navigator.geolocation.getCurrentPosition((p) => res({ lat: p.coords.latitude, lng: p.coords.longitude, accuracy: p.coords.accuracy }), () => res(null), { timeout: 8000, maximumAge: 60_000 });
  });
}
